import Base from '../base';

class Users extends Base {
	getList(is_ru) {
		const api = this._api.url('/users').query({
			isru: is_ru || undefined,
			roles: 'ADMIN,LOGIST,LOGIST_RU'
		}).GET;

		return this.request(api);
	}

	createUser(body) {
		const api = this._api
			.url('/user')
			.data(body)
			.POST;
		return this.request(api);
	}

	editUser(body) {
		const api = this._api
			.url(`/user/${body.id}`)
			.data(body)
			.PUT;
		return this.request(api);
	}

	deleteUser(id) {
		const api = this._api
			.url(`/user/${id}`)
			.DELETE;
		return this.request(api);
	}

	getRoles() {
		const api = this._api
			.url('/roles')
			.GET;
		return this.request(api);
	}

	getUserRoles(id) {
		const api = this._api
			.url(`/user/${id}/roles`)
			.GET;
		return this.request(api);
	}

	setRoles({ id, body }) {
		const api = this._api
			.url(`/user/${id}/roles`)
			.data(body)
			.PUT;
		return this.request(api);
	}

}

export default new Users();
